import script from "./BatchDisbursementRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchDisbursementRow.vue?vue&type=script&setup=true&lang=ts"

import "./BatchDisbursementRow.vue?vue&type=style&index=0&id=903bce74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-903bce74"]])

export default __exports__